import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Mail, Phone, MapPin, Clock, Calendar } from 'lucide-react';
import Header24 from './components/Header24';
import Footer24 from './components/Footer24';

const Contact24 = () => {
    const navigate = useNavigate();
    const [formData, setFormData] = useState({
        name: '',
        email: '',
        subject: '',
        message: '',
    });
    const [submitted, setSubmitted] = useState(false);
    const [appointmentMode, setAppointmentMode] = useState(false);
    const [appointmentData, setAppointmentData] = useState({
        name: '',
        email: '',
        date: '',
        time: '',
        note: '',
    });

    const handleChange = (field, value) => {
        setFormData(prev => ({ ...prev, [field]: value }));
    };

    const handleAppointmentChange = (field, value) => {
        setAppointmentData(prev => ({ ...prev, [field]: value }));
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        setSubmitted(true);
    };

    const handleAppointmentSubmit = (e) => {
        e.preventDefault();
        setSubmitted(true);
    };

    const inputStyle = {
        width: '100%',
        padding: '14px 16px',
        border: '1px solid #E5E5E5',
        fontFamily: "'Inter', sans-serif",
        fontSize: '14px',
        color: '#1A1A1A',
        background: '#FFFFFF',
        outline: 'none',
        transition: 'border-color 0.3s ease',
        boxSizing: 'border-box',
    };

    const labelStyle = {
        display: 'block',
        fontFamily: "'Inter', sans-serif",
        fontSize: '12px',
        fontWeight: 500,
        letterSpacing: '0.5px',
        color: '#6B6B6B',
        marginBottom: '8px',
    };

    return (
        <>
            <style>{`
                @import url('https://fonts.googleapis.com/css2?family=Playfair+Display:ital,wght@0,400;0,500;0,600;0,700;0,800;1,400;1,500&family=Inter:wght@300;400;500;600;700&display=swap');

                .dhara-contact {
                    min-height: 100vh;
                    background: #FFFFFF;
                }
                .dhara-contact-hero {
                    max-width: 800px;
                    margin: 0 auto;
                    padding: 80px 40px 0;
                    text-align: center;
                }
                .dhara-contact-title {
                    font-family: 'Playfair Display', serif;
                    font-size: 48px;
                    font-weight: 400;
                    color: #1A1A1A;
                    margin-bottom: 16px;
                    letter-spacing: -1px;
                }
                .dhara-contact-subtitle {
                    font-family: 'Inter', sans-serif;
                    font-size: 16px;
                    color: #6B6B6B;
                    font-weight: 300;
                    line-height: 1.7;
                    max-width: 500px;
                    margin: 0 auto;
                }

                .dhara-contact-toggle {
                    display: flex;
                    justify-content: center;
                    gap: 0;
                    margin: 60px auto 0;
                    max-width: 400px;
                }
                .dhara-contact-toggle-btn {
                    flex: 1;
                    padding: 14px 24px;
                    font-family: 'Inter', sans-serif;
                    font-size: 13px;
                    font-weight: 400;
                    letter-spacing: 0.5px;
                    border: 1px solid #E5E5E5;
                    background: transparent;
                    color: #6B6B6B;
                    cursor: pointer;
                    transition: all 0.3s ease;
                }
                .dhara-contact-toggle-btn.active {
                    background: #1A1A1A;
                    color: #FFFFFF;
                    border-color: #1A1A1A;
                }
                .dhara-contact-toggle-btn:first-child {
                    border-right: none;
                }

                .dhara-contact-layout {
                    max-width: 1100px;
                    margin: 0 auto;
                    padding: 60px 40px 120px;
                    display: grid;
                    grid-template-columns: 1fr 1fr;
                    gap: 100px;
                    align-items: start;
                }
                .dhara-contact-info {
                    padding-top: 20px;
                }
                .dhara-contact-info-item {
                    display: flex;
                    gap: 20px;
                    margin-bottom: 40px;
                    align-items: flex-start;
                }
                .dhara-contact-info-icon {
                    color: #00553A;
                    margin-top: 2px;
                    flex-shrink: 0;
                }
                .dhara-contact-info-label {
                    font-family: 'Inter', sans-serif;
                    font-size: 11px;
                    font-weight: 600;
                    letter-spacing: 2px;
                    text-transform: uppercase;
                    color: #1A1A1A;
                    margin-bottom: 8px;
                }
                .dhara-contact-info-text {
                    font-family: 'Inter', sans-serif;
                    font-size: 14px;
                    color: #6B6B6B;
                    line-height: 1.7;
                }
                .dhara-contact-field {
                    margin-bottom: 20px;
                }
                .dhara-contact-submit {
                    width: 100%;
                    height: 52px;
                    background: #00553A;
                    color: #FFFFFF;
                    border: none;
                    font-family: 'Inter', sans-serif;
                    font-size: 13px;
                    font-weight: 500;
                    letter-spacing: 1.5px;
                    text-transform: uppercase;
                    cursor: pointer;
                    transition: background 0.3s ease;
                    margin-top: 12px;
                }
                .dhara-contact-submit:hover {
                    background: #006B4A;
                }
                .dhara-contact-success {
                    text-align: center;
                    padding: 60px 20px;
                }
                .dhara-contact-success-title {
                    font-family: 'Playfair Display', serif;
                    font-size: 28px;
                    color: #1A1A1A;
                    margin-bottom: 12px;
                }
                .dhara-contact-success-text {
                    font-family: 'Inter', sans-serif;
                    font-size: 15px;
                    color: #6B6B6B;
                    line-height: 1.7;
                }

                input:focus, textarea:focus, select:focus {
                    border-color: #00553A !important;
                }

                @media (max-width: 768px) {
                    .dhara-contact-hero { padding: 40px 20px 0; }
                    .dhara-contact-title { font-size: 32px; }
                    .dhara-contact-layout {
                        grid-template-columns: 1fr;
                        gap: 48px;
                        padding: 40px 20px 80px;
                    }
                }
            `}</style>

            <Header24 />

            <main className="dhara-contact">
                <div className="dhara-contact-hero">
                    <h1 className="dhara-contact-title">Get in Touch</h1>
                    <p className="dhara-contact-subtitle">
                        We would love to hear from you. Whether you have a question about a piece,
                        need styling advice, or wish to book a private appointment.
                    </p>

                    <div className="dhara-contact-toggle">
                        <button
                            className={`dhara-contact-toggle-btn ${!appointmentMode ? 'active' : ''}`}
                            onClick={() => { setAppointmentMode(false); setSubmitted(false); }}
                        >
                            Send a Message
                        </button>
                        <button
                            className={`dhara-contact-toggle-btn ${appointmentMode ? 'active' : ''}`}
                            onClick={() => { setAppointmentMode(true); setSubmitted(false); }}
                        >
                            Book Appointment
                        </button>
                    </div>
                </div>

                <div className="dhara-contact-layout">
                    {/* Info */}
                    <div className="dhara-contact-info">
                        <div className="dhara-contact-info-item">
                            <MapPin size={20} strokeWidth={1.5} className="dhara-contact-info-icon" />
                            <div>
                                <div className="dhara-contact-info-label">Visit Us</div>
                                <div className="dhara-contact-info-text">
                                    Dhara Atelier<br />
                                    42 Hauz Khas Village<br />
                                    New Delhi 110016
                                </div>
                            </div>
                        </div>
                        <div className="dhara-contact-info-item">
                            <Mail size={20} strokeWidth={1.5} className="dhara-contact-info-icon" />
                            <div>
                                <div className="dhara-contact-info-label">Email</div>
                                <div className="dhara-contact-info-text">hello@dhara.in</div>
                            </div>
                        </div>
                        <div className="dhara-contact-info-item">
                            <Phone size={20} strokeWidth={1.5} className="dhara-contact-info-icon" />
                            <div>
                                <div className="dhara-contact-info-label">Phone</div>
                                <div className="dhara-contact-info-text">+91 98765 43210</div>
                            </div>
                        </div>
                        <div className="dhara-contact-info-item">
                            <Clock size={20} strokeWidth={1.5} className="dhara-contact-info-icon" />
                            <div>
                                <div className="dhara-contact-info-label">Studio Hours</div>
                                <div className="dhara-contact-info-text">
                                    Tuesday &ndash; Saturday<br />
                                    11:00 AM &ndash; 7:00 PM<br />
                                    <span style={{ fontStyle: 'italic' }}>By appointment on Sundays</span>
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* Form */}
                    <div>
                        {submitted ? (
                            <div className="dhara-contact-success">
                                <h2 className="dhara-contact-success-title">
                                    {appointmentMode ? 'Appointment Requested' : 'Message Sent'}
                                </h2>
                                <p className="dhara-contact-success-text">
                                    {appointmentMode
                                        ? 'We will confirm your virtual appointment within 24 hours. Check your inbox for details.'
                                        : 'Thank you for reaching out. We will respond within 24 hours.'
                                    }
                                </p>
                            </div>
                        ) : appointmentMode ? (
                            <form onSubmit={handleAppointmentSubmit}>
                                <div className="dhara-contact-field">
                                    <label style={labelStyle}>Full Name</label>
                                    <input
                                        style={inputStyle}
                                        value={appointmentData.name}
                                        onChange={(e) => handleAppointmentChange('name', e.target.value)}
                                        required
                                    />
                                </div>
                                <div className="dhara-contact-field">
                                    <label style={labelStyle}>Email</label>
                                    <input
                                        style={inputStyle}
                                        type="email"
                                        value={appointmentData.email}
                                        onChange={(e) => handleAppointmentChange('email', e.target.value)}
                                        required
                                    />
                                </div>
                                <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '16px' }}>
                                    <div className="dhara-contact-field">
                                        <label style={labelStyle}>Preferred Date</label>
                                        <input
                                            style={inputStyle}
                                            type="date"
                                            value={appointmentData.date}
                                            onChange={(e) => handleAppointmentChange('date', e.target.value)}
                                            required
                                        />
                                    </div>
                                    <div className="dhara-contact-field">
                                        <label style={labelStyle}>Preferred Time</label>
                                        <select
                                            style={inputStyle}
                                            value={appointmentData.time}
                                            onChange={(e) => handleAppointmentChange('time', e.target.value)}
                                            required
                                        >
                                            <option value="">Select</option>
                                            <option value="11:00">11:00 AM</option>
                                            <option value="12:00">12:00 PM</option>
                                            <option value="13:00">1:00 PM</option>
                                            <option value="14:00">2:00 PM</option>
                                            <option value="15:00">3:00 PM</option>
                                            <option value="16:00">4:00 PM</option>
                                            <option value="17:00">5:00 PM</option>
                                            <option value="18:00">6:00 PM</option>
                                        </select>
                                    </div>
                                </div>
                                <div className="dhara-contact-field">
                                    <label style={labelStyle}>Note (optional)</label>
                                    <textarea
                                        style={{ ...inputStyle, minHeight: '100px', resize: 'vertical', fontFamily: "'Inter', sans-serif" }}
                                        value={appointmentData.note}
                                        onChange={(e) => handleAppointmentChange('note', e.target.value)}
                                        placeholder="Tell us what you're looking for..."
                                    />
                                </div>
                                <button type="submit" className="dhara-contact-submit">
                                    Book Virtual Appointment
                                </button>
                            </form>
                        ) : (
                            <form onSubmit={handleSubmit}>
                                <div className="dhara-contact-field">
                                    <label style={labelStyle}>Full Name</label>
                                    <input
                                        style={inputStyle}
                                        value={formData.name}
                                        onChange={(e) => handleChange('name', e.target.value)}
                                        required
                                    />
                                </div>
                                <div className="dhara-contact-field">
                                    <label style={labelStyle}>Email</label>
                                    <input
                                        style={inputStyle}
                                        type="email"
                                        value={formData.email}
                                        onChange={(e) => handleChange('email', e.target.value)}
                                        required
                                    />
                                </div>
                                <div className="dhara-contact-field">
                                    <label style={labelStyle}>Subject</label>
                                    <input
                                        style={inputStyle}
                                        value={formData.subject}
                                        onChange={(e) => handleChange('subject', e.target.value)}
                                    />
                                </div>
                                <div className="dhara-contact-field">
                                    <label style={labelStyle}>Message</label>
                                    <textarea
                                        style={{ ...inputStyle, minHeight: '160px', resize: 'vertical', fontFamily: "'Inter', sans-serif" }}
                                        value={formData.message}
                                        onChange={(e) => handleChange('message', e.target.value)}
                                        required
                                    />
                                </div>
                                <button type="submit" className="dhara-contact-submit">
                                    Send Message
                                </button>
                            </form>
                        )}
                    </div>
                </div>
            </main>

            <Footer24 />
        </>
    );
};

export default Contact24;
